import { useMutation } from '@tanstack/react-query';
import api from '@/shared/api';
import config from '@/config';
var extractDocumentDataPreview = function (documentId) {
    return api.base
        .post("".concat(config.appUrls.api, "/api/DocumentExtraction/extractPreview"), { documentId: documentId })
        .then(function (_a) {
        var data = _a.data;
        return data;
    });
};
var useExtractDocumentDataPreview = function () {
    return useMutation({
        mutationFn: extractDocumentDataPreview,
    });
};
export default useExtractDocumentDataPreview;
